import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_INDASTRY = "GET_LIST_INDASTRY";
export const GET_LIST_INDASTRY_ERROR = "GET_LIST_INDASTRY_ERROR";
export const GET_LIST_INDASTRY_SUCCESS = "GET_LIST_INDASTRY_SUCCESS";

export const COUNT_LIST_INDASTRY = "COUNT_LIST_INDASTRY";
export const COUNT_LIST_INDASTRY_ERROR = "COUNT_LIST_INDASTRY_ERROR";
export const COUNT_LIST_INDASTRY_SUCCESS = "COUNT_LIST_INDASTRY_SUCCESS";

export const ADD_NEW_INDASTRY = "ADD_NEW_INDASTRY";
export const ADD_NEW_INDASTRY_ERROR = "ADD_NEW_INDASTRY_ERROR";
export const ADD_NEW_INDASTRY_SUCCESS = "ADD_NEW_INDASTRY_SUCCESS";

export const EDIT_A_INDASTRY = "EDIT_A_INDASTRY";
export const EDIT_A_INDASTRY_SUCCESS = "EDIT_A_INDASTRY_SUCCESS";
export const EDIT_A_INDASTRY_ERROR = "EDIT_A_INDASTRY_ERROR";

export const DELETE_A_INDASTRY = "DELETE_A_INDASTRY";
export const DELETE_A_INDASTRY_SUCCESS = "DELETE_A_INDASTRY_SUCCESS";
export const DELETE_A_INDASTRY_ERROR = "DELETE_A_INDASTRY_ERROR";

/**
 * Reducer
 */

const initialState = {
  indastries: [],
  error: false,
  count: 0,
  loading: false,
};

export const indastriesReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_INDASTRY:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_INDASTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        indastries: action.payload,
      };
    case GET_LIST_INDASTRY_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_LIST_INDASTRY:
      return {
        ...state,
      };
    case COUNT_LIST_INDASTRY_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_INDASTRY_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_INDASTRY:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_INDASTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        Indastry: action.payload,
      };
    case ADD_NEW_INDASTRY_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_INDASTRY:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_INDASTRY_SUCCESS: {
      const newItems = state.indastries.filter(
        (item) => item.id !== action.data.id
      );
      return {
        ...state,
        loading: false,
        newItems,
      };
    }
    case EDIT_A_INDASTRY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_INDASTRY:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_INDASTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        indastry: action.payload,
      };
    case DELETE_A_INDASTRY_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListIndastry = (order, limit, skip, where) => ({
  type: GET_LIST_INDASTRY,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListIndastry = (where) => ({
  type: COUNT_LIST_INDASTRY,
  data: {
    where,
  },
});

export const addNewIndastry = (name, email, phoneNumber, address, note) => ({
  type: ADD_NEW_INDASTRY,
  data: {
    name,
    email,
    phoneNumber,
    address,
    note,
  },
});

export const editIndastry = (id, name, note, email, phoneNumber, address) => ({
  type: EDIT_A_INDASTRY,
  data: {
    id,
    name,
    note,
    email,
    phoneNumber,
    address,
  },
});

export const deleteIndastry = (id) => ({
  type: DELETE_A_INDASTRY,
  data: {
    id,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListIndastry,
      countListIndastry,
      addNewIndastry,
      editIndastry,
      deleteIndastry,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListIndustryApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/industry", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListIndustryApi = (where) => {
  return apiCaller.getLogs("/mini-crm/industry", { ...where });
};
const addNewIndustryApi = (name, email, phoneNumber, address, note) => {
  return apiCaller.post("/mini-crm/industry", {
    name,
    email,
    phoneNumber,
    address,
    note,
  });
};
const editIndustryApi = (id, name, note, email, phoneNumber, address) => {
  return apiCaller.put(`/mini-crm/industry/${id}`, {
    name,
    note,
    email,
    phoneNumber,
    address,
  });
};
const deleteIndustryApi = (id) => {
  return apiCaller.del(`/mini-crm/industry/${id}`);
};

/**
 * sagas
 */

export const getListIndastryFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_INDASTRY);
    try {
      const res = yield call(
        getListIndustryApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_INDASTRY_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_INDASTRY_ERROR, error });
    }
  }
};

export const countIndastryFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_INDASTRY);
    try {
      const res = yield call(countListIndustryApi, action.data.where);
      yield put({
        type: COUNT_LIST_INDASTRY_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_INDASTRY_ERROR, error });
    }
  }
};

export const addNewIndastryFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_INDASTRY);
    try {
      const res = yield call(
        addNewIndustryApi,
        action.data.name,
        action.data.email,
        action.data.phoneNumber,
        action.data.address,
        action.data.note
      );
      yield put({ type: ADD_NEW_INDASTRY_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: ADD_NEW_INDASTRY_ERROR, error });
    }
  }
};

export const editIndastryFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_INDASTRY);
    try {
      const res = yield call(
        editIndustryApi,
        action.data.id,
        action.data.name,
        action.data.note,
        action.data.email,
        action.data.phoneNumber,
        action.data.address
      );
      yield put({ type: EDIT_A_INDASTRY_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_INDASTRY_ERROR, error });
    }
  }
};

export const deleteIndastryFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_INDASTRY);
    try {
      const res = yield call(deleteIndustryApi, action.data.id);
      yield put({ type: DELETE_A_INDASTRY_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_INDASTRY_ERROR, error });
    }
  }
};
